export const sensorsI18nTypeMap = {
    0: 'sensor.0', 
    1: 'sensor.1', 
    2: 'sensor.2',
    3: 'sensor.3',
}